import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import { getUserName } from '@redux/selectors/UserSelector';

import creaIcon from '@images/logos/vendor/crea-logo.svg';
import GAEventTracking from '@components/tracking/GAEventTracking';

const CreaWebformsWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: '#264887', minHeight: '231px' }}>
      <img alt="crea-icon" src={creaIcon} className="img-fluid mb-3" style={{ height: '60px' }} />
      <p className="mb-6" style={{ color: 'var(--darkText-2)' }}>
        <strong>CREA WEBForms® </strong>
        is a digital end-to-end solution for all your real estate transactions.
      </p>
      <Button
        onClick={() => {
          window.open('https://webforms.realtorlink.ca', '_blank');
          gaEventTracker('Opened CREA Webforms', `${username}`);
        }}
        variant="primary"
      >
        <i className="far fa-external-link mr-2" />
        CREA WEBForms®
      </Button>
    </div>
  );
};

export default CreaWebformsWidget;
